import React, { useCallback, useMemo } from 'react'
import { taricDuty } from '../../../commonApis'
import { useCurrentShipmentType } from '../../hooks/useCurrentShipmentType'
import { ValueBuildUpContext } from './ValueBuildUpContext'

const ESVBUProvider = ({
  children,
  saveFunc,
  updateFunc,
  invoiceData,
}) => {
  const { isImportShipment } = useCurrentShipmentType()

  const updateMerchandise = useCallback(
    (merchandise, invoiceId) => {
      const { merchandiseId, sumOfCustValue, sumOfStatValue, partyDependency } = merchandise

      let customValue = sumOfStatValue
      let statisticalValue = sumOfStatValue

      if (isImportShipment) {
        const { itemDuties } = invoiceData
          ?.find((inv) => inv.invoiceId === invoiceId)
          ?.merchandiseList?.find((merch) => merch.merchandiseId === merchandiseId)
        const totalDutiesTaxAmount = itemDuties?.reduce(
          (total, duty) =>
            duty?.taxType?.startsWith('A') ||
            duty?.taxType?.includes('3AI') ||
            duty?.taxType?.includes('1PL')
              ? total + Number(duty?.taxAmount)
              : total,
          0
        )
        customValue = sumOfCustValue
        statisticalValue = (
          totalDutiesTaxAmount +
          Number(customValue) +
          Number(sumOfStatValue)
        )?.toFixed(2)
      }

      updateFunc(invoiceId, merchandiseId, {
        customValue,
        statValue: statisticalValue,
        partyDependency,
      })
      saveFunc(merchandiseId, ['customValue', 'statValue'], invoiceId)
    },
    [updateFunc, saveFunc, invoiceData, isImportShipment]
  )

  const actions = useMemo(
    () => ({
      updateItemTab: (payload) => {
        payload.forEach((invoice) => {
          invoice.merchandise.forEach((merchandise) =>
            updateMerchandise(merchandise, invoice.invoiceId)
          )
        })
      },
    }),
    [updateMerchandise]
  )

  return <ValueBuildUpContext.Provider value={actions}>{children}</ValueBuildUpContext.Provider>
}

export default ESVBUProvider
